import { defineMessages } from 'react-intl';

export const searchBarMessages = defineMessages({
  placeholderGreeting: {
    id: 'search.bar.placeholderGreeting',
    defaultMessage: 'Hi',
  },
  placeholder: {
    id: 'search.bar.placeholder',
    defaultMessage: 'Search for a product...',
  },
  placeholderLoading: {
    id: 'search.bar.placeholderLoading',
    defaultMessage: 'Loading...',
  },
});

export const searchResultsMessages = defineMessages({
  formattedAllSearch: {
    id: 'search.results.allSearchResults',
    description: 'All searches for the query with count.',
    defaultMessage: 'All search {count} results',
  },
  productText: {
    id: 'search.result.type.product',
    description: 'Result type - Product',
    defaultMessage: 'Product',
  },
  categoryText: {
    id: 'search.result.type.category',
    description: 'Result type - Category',
    defaultMessage: 'Category',
  },
  contentPageText: {
    id: 'search.result.type.contentPage',
    description: 'Result type - Content Page',
    defaultMessage: 'Content Page',
  },
  formattedTitle: {
    id: 'search.result.count.singular',
    defaultMessage: '{total} {count, plural, one {result} other {results} } for {term}',
  },
  formattedProductTitle: {
    id: 'search.result.type.products',
    defaultMessage: 'Products',
  },
  formattedCategoryTitle: {
    id: 'search.result.type.categories',
    defaultMessage: 'Categories',
  },
  formattedContentPageTitle: {
    id: 'search.result.type.contentPages',
    defaultMessage: 'Information',
  },
  formattedNoResultsText: {
    id: 'header.search.noresult',
    defaultMessage: 'You can’t find a specific product? Request a quote and our experts will start searching for you. Within 48 hours our print professors will send you a quote.',
  },
  formattedNoResultsTitle: {
    id: 'header.search.sorry',
    defaultMessage: 'Sorry, no results found',
  },
  formattedNoResultsCTAButtonText: {
    id: 'header.search.ctaButtonText',
    defaultMessage: 'Request Quote',
  },
});
